import fstyles from "../frank.module.css";
import styles from "../results.module.css";

export default function Results({toHome}) {
  return (
    <div className={styles.page}>
      <h1>Official Marathon Results</h1>

      <button onClick={toHome} className={fstyles.button}>
        Back to Home
      </button>

      <div className={fstyles.resultsContainer}>
        <table>
          <thead>
            <tr>
              <th>Runner</th>
              <th>Time</th>
            </tr>
          </thead>
          <tbody>
            {[
              ["Cabo Bob", "1:03:01"],
              ["Frank Skabopolis", "4:10:03"],
              ["Jessica Day", "6:10:06"],
              ["Schmidt", "2:01:05"],
              ["Coach", "7:04:07"],
              ["Bruce Wayne", "1:06:04"],
              ["Batman (Not Bruce Wayne)", "9:05:02"],
              ["Joseph Kerr", "10:01:02"],
              ["Nick Miller", "6:07:03"],
              ["Cecilia Parekh", "4:11:03"],
              ["Edward Nygma", "1:14:01"],
              ["Pamela Isley", "5:01:01"],
              ["Victor Fries", "8:05:02"],
              ["Bob Dylan", "6:04:03"],
              ["Dylan Thomas", "1:02:05"],
              ["Thomas Eliot", "10:06:01"],
              ["Jordan Rivera", "1:07:05"],
              ["Casey Miller", "8:12:01"],
              ["Erin Jones", "7:01:02"],
              ["Vincent Chen", "5:08:02"],
              ["Alex Thompson", "3:01:04"],

            ].map(([name, time]) => (
              <tr key={name}>
                <td>{name}</td>
                <td>{time}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
